import sanitizeHtml from 'sanitize-html'

export const SanitizedHtml = ({ rawHtmlText }: { rawHtmlText: string }) => {
  const htmlText = sanitizeHtml(rawHtmlText)
  return <span dangerouslySetInnerHTML={{ __html: htmlText }} />
}
